import React from 'react';
import { Box, Container, Typography, Link, Divider } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link as RouterLink } from 'react-router-dom';
import BudgetCluesLogo from '../BudgetCluesLogo';

// Public static-page shell for Terms / Privacy. Works logged in or out.
const LegalLayout = ({ title, updated, children }) => (
  <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
    <Box sx={{ borderBottom: 1, borderColor: 'divider', py: 1.5 }}>
      <Container maxWidth="md" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Link component={RouterLink} to="/" underline="none" sx={{ display: 'flex' }}>
          <BudgetCluesLogo size="small" />
        </Link>
        <Link
          component={RouterLink}
          to="/login"
          underline="hover"
          sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, fontSize: '0.875rem', fontWeight: 600 }}
        >
          <ArrowBackIcon sx={{ fontSize: 16 }} /> Back to sign in
        </Link>
      </Container>
    </Box>
    <Container maxWidth="md" sx={{ py: { xs: 4, md: 6 } }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>{title}</Typography>
      {updated && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>Last updated: {updated}</Typography>
      )}
      <Divider sx={{ mb: 3 }} />
      <Box
        sx={{
          '& h2': { fontSize: '1.15rem', fontWeight: 700, mt: 4, mb: 1 },
          '& p, & li': { fontSize: '0.95rem', lineHeight: 1.7, color: 'text.primary' },
          '& ul': { pl: 3, mt: 1 },
        }}
      >
        {children}
      </Box>
    </Container>
  </Box>
);

export default LegalLayout;
